<template>
    <div>

        <el-drawer title="消息通知" :visible.sync="drawerSync"  direction="rtl"  :before-close="handleClose">
            <div style="padding: 10px;" v-for="(itme,index) in cardList" :key="index">

                <el-card style="margin-bottom: 10px;" v-if="itme.isType === 1" @click.native="handleClickTime(itme)">
                    <div style="display: flex;margin-bottom: 10px;">
                        <span style="background: #00b9ff;color: #fff; padding: 5px 10px;">电话沟通</span>
                        <span style="padding: 5px 10px;" :style="{  color: '#fff',  background: itme.state === 1 ? '#e8ae1c' : 'red'  }">{{ itme.state === 1 ? '未完成' : '进行中' }}</span>
                    </div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;">学生:  {{itme.name}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;">沟通内容:  {{itme.contcent}}</div>
                    <div style="width: 100%; text-align: end; ">{{itme.time}}</div>
                </el-card>

                <el-card style="margin-bottom: 10px;" v-else-if="itme.informationStatusName === '续费提醒'">
                    <div style="display: flex;margin-bottom: 10px;">
                        <span style="background: #00b9ff;color: #fff; padding: 5px 10px;">{{itme.informationStatusName}}</span>
                    </div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 0">{{itme.pairDTOList[0].pairKey}}: {{itme.pairDTOList[0].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 1">{{itme.pairDTOList[1].pairKey}}: {{itme.pairDTOList[1].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 2">{{itme.pairDTOList[2].pairKey}}: {{itme.pairDTOList[2].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 3">{{itme.pairDTOList[3].pairKey}}: {{itme.pairDTOList[3].pairValue}}</div>
                    <!-- <div style="width: 100%; text-align: end; ">{{itme.time}}</div> -->
                    <div style="display: flex;">
                        <el-button size="mini" style="background: #fff;color: #000;" @click.stop="handleState('知道了',itme)" type="primary">知道了</el-button>
                        <el-button size="mini" @click.stop="handleState('去处理',itme)" type="primary">去处理</el-button>
                    </div>
                </el-card>

                <el-card style="margin-bottom: 10px;" v-else-if="itme.informationStatusName === '成单金额待审批通知'">
                    <div style="display: flex;margin-bottom: 10px;">
                        <span style="background: #00b9ff;color: #fff; padding: 5px 10px;">{{itme.informationStatusName}}</span>
                    </div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 0">{{itme.pairDTOList[0].pairKey}}: {{itme.pairDTOList[0].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 1">{{itme.pairDTOList[1].pairKey}}: {{itme.pairDTOList[1].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 2">{{itme.pairDTOList[2].pairKey}}: {{itme.pairDTOList[2].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 3">{{itme.pairDTOList[3].pairKey}}: {{itme.pairDTOList[3].pairValue}}</div>
                    <!-- <div style="width: 100%; text-align: end; ">{{itme.time}}</div> -->
                    <div style="display: flex;">
                        <el-button size="mini" style="background: #fff;color: #000;" @click.stop="handleState('知道了',itme)" type="primary">知道了</el-button>
                        <el-button size="mini" @click.stop="handleState('去处理',itme)" type="primary">去处理</el-button>
                    </div>
                </el-card>


                <el-card style="margin-bottom: 10px;" v-else-if="itme.informationStatusName === '取消结课待审批通知'">
                    <div style="display: flex;margin-bottom: 10px;">
                        <span style="background: #00b9ff;color: #fff; padding: 5px 10px;">{{itme.informationStatusName}}</span>
                    </div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 0">{{itme.pairDTOList[0].pairKey}}: {{itme.pairDTOList[0].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 1">{{itme.pairDTOList[1].pairKey}}: {{itme.pairDTOList[1].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 2">{{itme.pairDTOList[2].pairKey}}: {{itme.pairDTOList[2].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 3">{{itme.pairDTOList[3].pairKey}}: {{itme.pairDTOList[3].pairValue}}</div>
                    <!-- <div style="width: 100%; text-align: end; ">{{itme.time}}</div> -->
                    <div style="display: flex;">
                        <el-button size="mini" style="background: #fff;color: #000;" @click.stop="handleState('知道了',itme)" type="primary">知道了</el-button>
                        <el-button size="mini" @click.stop="handleState('去处理',itme)" type="primary">去处理</el-button>
                    </div>
                </el-card>


                <el-card style="margin-bottom: 10px;" v-else-if="itme.informationStatusName === '课消审批待审批通知'">
                    <div style="display: flex;margin-bottom: 10px;">
                        <span style="background: #00b9ff;color: #fff; padding: 5px 10px;">{{itme.informationStatusName}}</span>
                    </div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 0">{{itme.pairDTOList[0].pairKey}}: {{itme.pairDTOList[0].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 1">{{itme.pairDTOList[1].pairKey}}: {{itme.pairDTOList[1].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 2">{{itme.pairDTOList[2].pairKey}}: {{itme.pairDTOList[2].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 3">{{itme.pairDTOList[3].pairKey}}: {{itme.pairDTOList[3].pairValue}}</div>
                    <!-- <div style="width: 100%; text-align: end; ">{{itme.time}}</div> -->
                    <div style="display: flex;">
                        <el-button size="mini" style="background: #fff;color: #000;" @click.stop="handleState('知道了',itme)" type="primary">知道了</el-button>
                        <el-button size="mini" @click.stop="handleState('去处理',itme)" type="primary">去处理</el-button>
                    </div>
                </el-card>


                <el-card style="margin-bottom: 10px;" v-else>
                    <div style="display: flex;margin-bottom: 10px;">
                        <span style="background: #00b9ff;color: #fff; padding: 5px 10px;">{{itme.informationStatusName}}</span>
                    </div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 0">{{itme.pairDTOList[0].pairKey}}: {{itme.pairDTOList[0].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 1">{{itme.pairDTOList[1].pairKey}}: {{itme.pairDTOList[1].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 2">{{itme.pairDTOList[2].pairKey}}: {{itme.pairDTOList[2].pairValue}}</div>
                    <div style="width: 100%; text-align: start; margin-bottom: 6px;" v-if="itme.pairDTOList.length > 3">{{itme.pairDTOList[3].pairKey}}: {{itme.pairDTOList[3].pairValue}}</div>
                    <!-- <div style="width: 100%; text-align: end; ">{{itme.time}}</div> -->
                    <div style="display: flex;">
                        <el-button size="mini" style="background: #fff;color: #000;" @click.stop="handleState('知道了',itme)" type="primary">知道了</el-button>
                    </div>
                </el-card>

            </div>

            <div style="padding-top: 40%;" v-if="cardList.length <= 0">
                <el-empty :image-size="200"></el-empty>
            </div>

        </el-drawer>


        <el-dialog :visible.sync="dialogVisible" width="60%"  :before-close="handleDialogVisibleClose">

            <div style="text-align: start;">
                <div style="margin-bottom: 10px;">学员: 滕家俊</div>
                <div style="margin-bottom: 10px;">联系电话: 13797468399</div>
                <div style="margin-bottom: 10px;">沟通时间: 2024-5-29 16:00-16:30</div>
                <div style="margin-bottom: 10px;">沟通教师: 单老师</div>
                <div style="margin-bottom: 10px;">助理: 小张</div>
                <div style="margin-bottom: 10px;">创建代办时间: 2024-5-29 16:00</div>
            </div>
            <el-divider></el-divider>
            <div>
                <h3 style="margin-bottom: 10px;">沟通内容</h3>
                <div style="text-indent: 66px;text-align: start;">英语，首次课后，考虑到孩子的知识基础和接受能力，课上能讲解和补充的知识点有限。后续会跟进学校进度讲解课本上的知识点，
                    复习已学习的知识点，针对学生薄弱的题型进行练习并讲解。但考虑到后续仍需讲解和练习的内容，孩子的学习基础和接受能力等，
                    仍可能发生期末考试成绩不理想的情况。
                </div>
            </div>
            <el-divider></el-divider>
            <div>
                <h3 style="margin-bottom: 20px;">待办状态</h3>
                <div style="display: flex;justify-content: space-evenly;">
                    <el-button :style="{ backgroundColor: backgroundColor1, borderColor: borderColor1, color: color1 }" @click="handleState('未完成')" type="primary">未完成<i style="margin-left: 7px;" class="el-icon-warning"></i></el-button>
                    <el-button :style="{ backgroundColor: backgroundColor2, borderColor: borderColor2, color: color2 }" @click="handleState('进行中')" type="primary">进行中<i style="margin-left: 7px;" class="el-icon-loading"></i></el-button>
                    <el-button :style="{ backgroundColor: backgroundColor3, borderColor: borderColor3, color: color3 }" @click="handleState('已完成')" type="primary">已完成<i style="margin-left: 7px;" class="el-icon-success"></i></el-button>
                </div>
            </div>
            <el-divider></el-divider>
            <div>
                <h3 style="margin-bottom: 20px;">办理结果</h3>
                <div style="">
                    <el-input type="textarea"  placeholder="请输入办理结果内容" :autosize="{ minRows: 6, maxRows: 6 }"  v-model="textInput"  maxlength="200" show-word-limit></el-input>
                </div>
            </div>
            <el-divider></el-divider>
            <div>
                <h3 style="margin-bottom: 20px;">回执附件</h3>
                <div style="">
                    <el-button style="background-color: rgb(25 171 239);border-color:rgb(25 171 239);width: 100%;" type="primary" icon="el-icon-plus" @click="handleUptaFlie"></el-button>
                </div>
                <div style="" v-if=" listFile && listFile.length > 0">
                   <div v-for="(itme,index) in listFile" :key="index">
                     <div style="margin-bottom: 20px;margin-top: 20px;">
                        <span style="color: #0c8adf;margin-right: 20px;" @click="handleShow(itme,index)">{{itme.name}}</span>
                        <i style="color: #f31341;" class="el-icon-close" @click="handleDelet(itme,index)"></i>
                     </div>
                   </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button style="background-color: #fff;border-color:black;color:black;" type="primary" @click="handleDialogVisibleClose">取消</el-button>
                <el-button style="background-color: rgb(25 171 239);border-color:rgb(25 171 239);" type="primary" @click="handleDialogVisiblePreserve">保存</el-button>
            </span>
        </el-dialog>



        <el-dialog title="上传资料" width="50%" style="padding: 50px 50px;" :visible.sync="uploadShowDlong" :before-close="uploadShowDlongCler" :close-on-click-modal="false">
            <el-upload class="upload-demo" style="height: 350px;"
                drag
                action="#"
                :on-remove="handleRemove"
                :beforeUpload="beforeUpload"
                :http-request="handleUpload"
                :on-error="handleError"
                :auto-upload="true"
                :limit="50"
                show-file-list
                :file-list="fileDataList">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div slot="footer" class="dialog-footer">
                <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="uploadShowDlongCler">取消</el-button>
                <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="uploadShowDlongSub">保存</el-button>
            </div>
        </el-dialog>



        <order-update v-if="showOrderUpdate" ref="orderUpdate" @handleEvent="handleEvent" @handleEventEimet="handleEventEimet"></order-update>
        <orderOrderDetailComponents ref="OrderDetail" @handleDetailEvent="handleDetailEvent"  v-if="orderDetailComponentsShow" :orderFormComponentsType="orderFormComponentsType" :orderFormComponentsIDnew="orderFormComponentsIDnew" :orderFormComponentsID="orderFormComponentsID"></orderOrderDetailComponents>

    </div>
</template>



<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import OrderUpdate from "./OrderUpdate.vue";
import orderOrderDetailComponents from './OrderDetail.vue'


export default {
    components: {  OrderUpdate, orderOrderDetailComponents, },
    props:{
      records:{
         default:[],
         type:Array
      }
    },
    data(){
        return{

            orderFormComponentsIDnew:'',

            orderDetailComponentsShow: false,
            orderFormComponentsID:'',
            orderFormComponentsType:'',


            drawerSync:true,
            showOrderUpdate:false,
            cardList:[],

            dialogVisible:false,
            textInput:'',
            listFile:[],

            fileDataList:[],
            uploadShowDlong:false,

            backgroundColor1:'#f02042',
            borderColor1:'#f02042',
            backgroundColor2:'#fff',
            borderColor2:'#a8a8a8',
            backgroundColor3:'#fff',
            borderColor3:'#a8a8a8',
            color1:'#fff',
            color2:'#453f3f',
            color3:'#453f3f',


            stateType: 1,

        }
    },

    mounted(){
        this.cardList = this.records
        this.handleMessges()
    },

    methods:{

        handleEventCole(event){
            this.orderUpdateComponentsShow = event
        },

        handleEventEimet(){
            axios.post(`${apiBaseUrl}/information/findList`, { pageNum:1, pageSize: 100000 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                if (res.data.code == 200) {
                    this.cardList = res.data.data.records ? res.data.data.records : []
                    this.$emit('handleEvent', res.data.data.total)
                } else {
                    this.$message({  message: res.data.message,   type: "error"})
                }
            }).catch(err => { this.$message({  message: err,   type: "error"})})
        },

        handleMessges(){
            axios.post(`${apiBaseUrl}/information/findList`, { pageNum:1, pageSize: 100000 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                if (res.data.code == 200) {
                    this.cardList = res.data.data.records ? res.data.data.records : []
                    this.$emit('handleEvent', res.data.data.total)
                } else {
                    this.$message({  message: res.data.message,   type: "error"})
                }
            }).catch(err => { this.$message({  message: err,   type: "error"})})
        },

        handleGotIt(informationId){
            axios.post(`${apiBaseUrl}/information/updateStatus/${informationId}`, {  },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                if (res.data.code == 200) {
                    this.$message({  message: res.data.message,   type: "success"})
                    this.handleMessges()
                } else {
                    this.$message({  message: res.data.message,   type: "error"})
                }
            }).catch(err => { this.$message({  message: err,   type: "error"})})
        },

        handleClose(){
            this.$emit('handleEventBts', false)
        },


        handleClickTime(itme){
            console.log(itme)

            this.dialogVisible = true
        },

        handleDialogVisibleClose(){
            this.dialogVisible = false
            this.handleClrInfo()
        },
        handleDialogVisiblePreserve(){
            this.dialogVisible = false
        },

        handleClrInfo(){
            this.listFile = []
            this.textInput = ''


            this.stateType = 1
            this.backgroundColor1 = '#f02042'
            this.borderColor1 = '#f02042'
            this.backgroundColor2 = '#fff'
            this.borderColor2 = '#a8a8a8'
            this.backgroundColor3 = '#fff'
            this.borderColor3 = '#a8a8a8'
            this.color1 = '#fff'
            this.color2 = '#453f3f'
            this.color3 = '#453f3f'

        },

        handleUptaFlie(){
            this.uploadShowDlong = true
        },

        handleDelet(itme,index){
            this.listFile =  this.listFile.slice(0, index).concat(this.listFile.slice(index + 1));
        },

        uploadShowDlongCler(){
            this.fileDataList = []
            this.uploadShowDlong = false
        },

        uploadShowDlongSub(){
           this.listFile = [...this.listFile,...this.fileDataList]
           this.uploadShowDlong = false
           this.fileDataList = []
        },



        handleState(type,itme){
            if(type === '未完成'){
                this.backgroundColor1 = '#f02042'
                this.borderColor1 = '#f02042'
                this.backgroundColor2 = '#fff'
                this.borderColor2 = '#a8a8a8'
                this.backgroundColor3 = '#fff'
                this.borderColor3 = '#a8a8a8'
                this.color1 = '#fff'
                this.color2 = '#453f3f'
                this.color3 = '#453f3f'

                this.stateType = 1
            }

            if(type === '进行中'){
                this.backgroundColor1 = '#fff'
                this.borderColor1 = '#a8a8a8'
                this.backgroundColor2 = 'rgb(239 166 40)'
                this.borderColor2 = 'rgb(239 166 40)'
                this.backgroundColor3 = '#fff'
                this.borderColor3 = '#a8a8a8'
                this.color1 = '#453f3f'
                this.color2 = '#fff'
                this.color3 = '#453f3f'

                this.stateType = 2
            }

            if(type === '已完成'){
                this.backgroundColor1 = '#fff'
                this.borderColor1 = '#a8a8a8'
                this.backgroundColor2 = '#fff'
                this.borderColor2 = '#a8a8a8'
                this.backgroundColor3 = 'rgb(16 231 11)'
                this.borderColor3 = 'rgb(16 231 11)'
                this.color1 = '#453f3f'
                this.color2 = '#453f3f'
                this.color3 = '#fff'


                this.stateType = 3
            }

            if(type === '知道了'){
                // this.$message({ message:'操作成功~' , type: 'success' })
                this.handleGotIt(itme.informationId)
            }

            if(type === '去处理'){

                if(itme.informationStatusName ===  '续费提醒'){
                    this.showOrderUpdate = true
                    this.$nextTick(() => {
                        this.$refs.orderUpdate.init(itme.customerId)
                    })
                }

                if(itme.informationStatusName ===  '成单金额待审批通知'){
                    this.orderFormComponentsType = '审批'
                    this.orderFormComponentsID = itme.customerId
                    this.orderDetailComponentsShow = true
                    this.$nextTick(() => {
                        this.$refs.OrderDetail.orderCustomerAudit(itme.customerAuditId)
                    })
                }


                if(itme.informationStatusName ===  '取消结课待审批通知'){
                    // this.orderFormComponentsType = '审批'
                    // this.orderFormComponentsID = itme.customerId
                    // this.orderFormComponentsIDnew = itme.id
                    // this.orderDetailComponentsShow = true
                    // this.$nextTick(() => {
                    //     this.$refs.OrderDetail.orderCustomerAudits(itme.cancelEndingId)
                    // })


                    this.$emit('handleEventBts', false)
                    this.$router.push('/CancelCourseClosureApproval')

                }


                if(itme.informationStatusName ===  '课消审批待审批通知'){
                    // this.orderFormComponentsType = '审批'
                    // this.orderFormComponentsID = itme.customerId
                    // this.orderFormComponentsIDnew = itme.id
                    // this.orderDetailComponentsShow = true
                    // this.$nextTick(() => {
                    //     this.$refs.OrderDetail.orderCustomerAudits(itme.classSalesAuditId)
                    // })

                  this.$emit('handleEventBts', false)
                  this.$router.push('/CourseCancellationApproval')
                }

            }


        },

        handleDetailEvent(event){
          this.orderDetailComponentsShow = event
          this.$emit('handleEventBts', false)
        },

        handleEvent(event){
            this.showOrderUpdate = event
            this.$message({ message:'处理成功~' , type: 'success' })
        },

        handleShow(ImgObj){
            let { url } = ImgObj
            let ele = document.createElement('a')
            ele.setAttribute('href', url)
            document.body.appendChild(ele)
            ele.click()
        },


        handleRemove(file, fileList){
            this.fileDataList = fileList
        },

        getFileName(name) {
             return name.substring(name.lastIndexOf("."))
        },

        beforeUpload(file, fileList){
            loadingUtils.startLoading()
            const fileExtensions = this.getFileName(file.name) === ".pdf" ||
                this.getFileName(file.name) === ".bmp" ||
                this.getFileName(file.name) === ".tif" ||
                this.getFileName(file.name) === ".gif" ||
                this.getFileName(file.name) === ".pcx" ||
                this.getFileName(file.name) === ".svg" ||
                this.getFileName(file.name) === ".psd" ||
                this.getFileName(file.name) === ".webp" ||
                this.getFileName(file.name) === ".apng" ||
                this.getFileName(file.name) === ".ai" ||
                this.getFileName(file.name) === ".avif" ||
                this.getFileName(file.name) === ".png" ||
                this.getFileName(file.name) === ".pdf"||
                this.getFileName(file.name) === ".mp4"||
                this.getFileName(file.name) === ".excel"||
                this.getFileName(file.name) === ".doc"||
                this.getFileName(file.name) === ".ppt"||
                this.getFileName(file.name) === ".mp3"||
                this.getFileName(file.name) === ".xls"||
                this.getFileName(file.name) === ".xlsx"||
                this.getFileName(file.name) === ".pptx"||
                this.getFileName(file.name) === ".docx"||
                this.getFileName(file.name) === ".txt"||
                this.getFileName(file.name) === ".jpg";
            const max20M = file.size / 1024 / 1024 < 1000;

            if (!fileExtensions) {
                this.$message({type: 'warning', message: '格式不符合要求，请上传有效格式~' })
                loadingUtils.endLoading()
            }

            return fileExtensions && max20M
        },
        handleUpload(option){
            let obj = option.file.name
            let index = obj.lastIndexOf(".")
            obj = obj.substring(index, obj.length)
            let objName = option.file.name
            put(`mz_pc/${objName}`, option.file).then((res) => {
                loadingUtils.endLoading()

                let replacedStr = res.name.replace("mz_pc/", "")
                res.name =  replacedStr

                this.fileDataList.push(res)

                signatureUrl(`mz_pc/${objName}`).then((res) => {})
            });
        },

        handleError(){
            loadingUtils.endLoading()
        },









    }


}
</script>


<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/newsMessage-components/message.vue